import React, { useCallback, useState } from "react"
import CommonTypo from "../../../components/CommonTypo"
import { Autocomplete, Box, TextField, Paper, Button } from "@mui/material"
import NewButton from "../../../components/NewButton"
import { makeStyles } from "@material-ui/core";
import _debounce from "lodash/debounce";
import palette from "../../../theme/palette";
import { pxToRem } from "../../../theme/typography";
import shape from "../../../theme/shape";
import { onboardingPlansService } from "../../../services/onboardingPlans";

const useStyles = makeStyles((theme) => ({
    selectionBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "42px",
        gap: "8px",
        borderRadius: "20px",
        border: "1px solid var(--color-border)",
        paddingTop: "8px",
        paddingRight: "24px",
        paddingBottom: "8px",
        paddingLeft: "24px",
        // "&:hover": {
        //     border: "1px solid var(--color-new-main)",
        // },
    },

}))

const Step6 = ({ setNextStep, setPreviousStep, planInfluences, setPlanInfluences, planSelectedInfluences, setSelectedPlanInfluences, isDarkMode = false }) => {
    const classes = useStyles()
    // let fundData = [...(planSelectedInfluences || [])]
    // let found = fundData.find(ite => ite.influenceId === it.influenceId)
    // if (props?.planStep === 1) {
    // fundData = [...(props.planSelectedInfluences || [])]
    // found = fundData.find(ite => ite.influenceId === it.influenceId)
    // }
    // if (props?.planStep === 2) {
    //     fundData = [...(props.planSelectedInfluences || [])]
    //     found = fundData.find(ite => ite.influenceId === it.influenceId)
    // }
    // if (props?.planStep === 3) {
    //     fundData = [...(props.planSelectedReflectives || [])]
    //     found = fundData.find(ite => ite.reflectiveId === it.reflectiveId)
    // }
    return <>
        <Box display={"flex"} flexDirection={"column"} gap={"4px"} alignItems={"center"}>
            <CommonTypo size={32} fontWeight={700} color="var(--color-text-primary)" lineHeight={36} extraSx={{
                whiteSpace: "nowrap"
            }}>Now, influences</CommonTypo>
            <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)" lineHeight={22} >Actions, habits, or factors that may affect your outcomes. By tracking these, you'll discover which activities help you progress</CommonTypo>
        </Box>

        <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexWrap={"wrap"} sx={{
            maxHeight: '38vh',
            width: "100%",
            overflowY: 'auto',
            gap: "12px"
        }}>
            {planInfluences.map(it => {
                let fundData = []
                let found = undefined
                // if (props?.planStep === 1) {
                fundData = [...(planSelectedInfluences || [])]
                found = fundData.find(ite => ite.influenceId === it.influenceId)
                // }
                // if (props?.planStep === 2) {
                //     fundData = [...(props.planSelectedInfluences || [])]
                //     found = fundData.find(ite => ite.influenceId === it.influenceId)
                // }
                // if (props?.planStep === 3) {
                //     fundData = [...(props.planSelectedReflectives || [])]
                //     found = fundData.find(ite => ite.reflectiveId === it.reflectiveId)
                // }
                return <Box className={classes.selectionBox} sx={{

                    border: found ? "1px solid var(--color-new-main)" : "1px solid var(--color-border)",
                }} onClick={() => {
                    if (found) {
                        fundData = fundData.filter(ite => ite.influenceId !== it.influenceId)
                        setSelectedPlanInfluences(fundData)
                        // const foundAlreadySelected = props.secondselectedPlans.find(ite => ite.categoryId === it.categoryId)
                        // if (foundAlreadySelected) {
                        //     // setSecondSelectedPlans([])
                        //     // setSelectedPlanInfluences([])
                        //     // setSelectedPlanInfluences([])
                        //     // setSelectedPlanReflectives([])
                        // }
                    } else {
                        if (fundData.length < 5) {
                            fundData.push(it)
                            setSelectedPlanInfluences(fundData)
                        }
                    }
                }}>
                    <CommonTypo size={16} color={isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'}>{it.name}</CommonTypo>
                </Box>
            })}
        </Box>
        <CommonTypo size={16} color={isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'}>Select up to <strong>5 influences</strong></CommonTypo>

    </>
}

export default Step6